import { handleActions, combineActions } from 'redux-actions'
import * as authActions from '../actions/auth'

const initialState = {
  authChecked: false,
  subscriber_id: null,
  loggedIn: false,
  logginIn: false,
  succeed: false,
  failed: false
}

export default handleActions(
  {
    [authActions.setSession]: (state, action) => {
      const { subscriber_id = null } = action.payload
      return {
        ...state,
        subscriber_id,
        loggedIn: true
      }
    },
    [combineActions(authActions.logIn, authActions.signUp)]: state => ({
      ...state,
      logginIn: true,
      succeed: false,
      failed: false
    }),
    [combineActions(
      authActions.logInSuccess,
      authActions.signUpSuccess
    )]: state => ({
      ...state,
      logginIn: false,
      succeed: true,
      failed: false
    }),
    [combineActions(authActions.logInFail, authActions.signUpFail)]: state => ({
      ...state,
      logginIn: false,
      succeed: false,
      failed: true
    }),
    [authActions.authChecked]: state => ({
      ...state,
      authChecked: true
    })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/store/reducers/auth.js